module.exports = __webpack_public_path__ + "static/media/door.cb21b1ba.svg";